import React, { Fragment } from 'react';
import { ReplacementType } from '../../../lib/REST/types';
import { BlocksFunctionsType } from '../types';
import { BlockSelectorsReplacer } from '../BlockSelectorReplacer';
import { Script } from '../../AppUserInterface/Script';
import { useOnReplacementsRendered } from '../../../hooks/useOnReplacementsRendered';

type BlockReplacerType = {
	campaignId: string;
	contentId: string;
	customJs?: string;
	correlationId?: string | null;
	replacements: ReplacementType[] | null;
} & BlocksFunctionsType;

export function BlockReplacer({
	contentId,
	campaignId,
	clickLinkData,
	correlationId,
	customJs,
	replacements,
	onAppear,
	onRendered,
}: BlockReplacerType) {
	/**
	 * Filter Replacements based on selector availability on dom.
	 */
	const filteredBlockReplacementsForAvailableSelectors =
		replacements?.filter(({ selector }: ReplacementType) =>
			document.getElementById(selector)
		) || null;

	const {
		areAllDomReadyReplacementsRendered,
		onItemRendered,
		lastComponentRenderedAt,
	} = useOnReplacementsRendered({
		componentList: filteredBlockReplacementsForAvailableSelectors || [],
		onAllChildrenRendered: () => {},
	});

	const container = document.head || document.getElementsByTagName('head')[0];

	const isCustomJS = typeof customJs === 'string' && customJs !== '';

	const customJsHandlers =
		replacements?.length === 0
			? {
					onRendered: () =>
						onRendered({ campaignId, contentId, correlationId }),
			  }
			: {};

	return (
		<Fragment key={campaignId}>
			<BlockSelectorsReplacer
				replacements={replacements}
				correlationId={correlationId}
				campaignId={campaignId}
				contentId={contentId}
				clickLinkData={clickLinkData}
				onAppear={onAppear}
				onRendered={onRendered}
				onReplacementsRendered={onItemRendered}
			/>
			{isCustomJS && areAllDomReadyReplacementsRendered && (
				<Script
					url={customJs}
					container={container}
					{...customJsHandlers}
					lastComponentRenderedAt={lastComponentRenderedAt}
				/>
			)}
		</Fragment>
	);
}
